import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ClarityInEveryEntry from "./sections/ClarityInEveryEntry";
import TheLedgerAdvantage from "./sections/TheLedgerAdvantage";
import PrecisionSolutions from "./sections/PrecisionSolutions";
import TrustedByGrowthMindedBrands from "./sections/TrustedByGrowthMindedBrands";
import GrowthInsights from "./sections/GrowthInsights";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ClarityInEveryEntry />
      <TheLedgerAdvantage />
      <PrecisionSolutions />
      <TrustedByGrowthMindedBrands />
      <GrowthInsights />
      <Footer />
    </div>;
}